import React from "react";
import PropTypes from "prop-types";
import CustomFormIds from "./customFormIds";
import EntityMenuCustomForm from "../Navigations/AddEntity/EntityMenuCustomForms";
import AddCustomCards from "./AddCustomCards/AddCustomCards";
import AddCompletionStatementForm from "./AddCompletionStatement/AddCompletionStatementForm";
import AddPricingPerimeterForm from "./AddPricingPerimeter/AddPricingPerimeterForm";
import { useParams } from "react-router";

const M_ManageCustomForm = (props) => {
  const { handleClose, open, customFormId, title, templateId, afterClose } =
    props;
  const { crmId } = useParams();
  let component = null;
  switch (customFormId) {
    case CustomFormIds.ADD_LOAN:
    case CustomFormIds.ADD_BORROWER:
      component = (
        <EntityMenuCustomForm
          open={open}
          onClose={handleClose}
          title={title}
          afterClose={afterClose}
          entity={{ recordId: crmId, templateId: templateId, name: title }}
          formtypeId={customFormId}
          isEditForm={true}
        />
      );
      break;
    case CustomFormIds.ADD_PAYMENT_DETAILS:
      component = (
        <AddCustomCards
          open={open}
          onClose={handleClose}
          title={title}
          afterClose={afterClose}
          entity={{ recordId: crmId, templateId: templateId, name: title }}
          formtypeId={customFormId}
        />
      );
      break;
    case CustomFormIds.ADD_COMPLETION_STATEMENT:
      component = (
        <AddCompletionStatementForm
          open={open}
          onClose={handleClose}
          title={title}
          afterClose={afterClose}
        />
      );
      break;
    case CustomFormIds.ADD_PRICING_PERIMETER:
      component = (
        <AddPricingPerimeterForm
          open={open}
          onClose={handleClose}
          title={title}
          afterClose={afterClose}
        />
      );
      break;
    default:
      component = null;
      break;
  }

  return component;
};

M_ManageCustomForm.propTypes = {
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string,
  templateId: PropTypes.string,
  customFormId: PropTypes.string,
  afterClose: PropTypes.func,
};

export default M_ManageCustomForm;
